import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import IndexPage from 'flarum/forum/components/IndexPage';
import LinkButton from 'flarum/common/components/LinkButton';

// Models
import CourseArticle from './models/CourseArticle';
import KnowledgeLevel from './models/KnowledgeLevel';
import KnowledgeModule from './models/KnowledgeModule';
import StructuredCourse from './models/StructuredCourse';
import CourseCompletion from './models/CourseCompletion';
import QuizQuestion from './models/QuizQuestion';
import CreditExchangeRate from './models/CreditExchangeRate';

// Pages
import CourseLibraryPage from './components/CourseLibraryPage';
import CourseDetailPage from './components/CourseDetailPage';
import ArticleReaderPage from './components/ArticleReaderPage';

app.initializers.add('taro-course-library', () => {
  // Register all models — 键名必须精确匹配 JSON:API type（Serializer 中的 $type）
  app.store.models['taro-course-articles'] = CourseArticle;
  app.store.models['knowledge-levels'] = KnowledgeLevel;
  app.store.models['taro-knowledge-modules'] = KnowledgeModule;
  app.store.models['structured-courses'] = StructuredCourse;
  app.store.models['course-completions'] = CourseCompletion;
  app.store.models['quiz-questions'] = QuizQuestion;
  app.store.models['credit-exchange-rates'] = CreditExchangeRate;

  // Register SPA routes
  app.routes.courseLibrary = {
    path: '/course-library',
    component: CourseLibraryPage,
  };

  app.routes.courseDetail = {
    path: '/course-library/course/:id',
    component: CourseDetailPage,
  };

  app.routes.articleReader = {
    path: '/course-library/article/:id',
    component: ArticleReaderPage,
  };

  // Nav item — 课程中心
  extend(IndexPage.prototype, 'navItems', function (items) {
    items.add(
      'courseLibrary',
      <LinkButton href={app.route('courseLibrary')} icon="fas fa-book-reader">
        课程中心
      </LinkButton>,
      75
    );
  });
});
